class TabsComponent extends HTMLElement {
    constructor(){
        super();
        this.tabs = this.querySelectorAll('[role="tab"]');
        this.panels = this.querySelectorAll('[role="tabpanel"]');
    }
    connectedCallback(){
        this.tabs.forEach(tab => {
            tab.addEventListener('click',(e) => {
                this.switchTab(e.currentTarget);
            })
        })
    }
    switchTab(selectedTab) {
        const targetId = selectedTab.getAttribute('aria-controls');
        // update tabs state
        this.tabs.forEach(tab => {
            tab.setAttribute('aria-selected', tab === selectedTab);
        });

        // update panels visibility
        this.panels.forEach(panel => {
            panel.hidden = panel.id !== targetId;
        })
    }
}
customElements.define('tabs-component', TabsComponent);

// Base Slider

class BaseSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.currentIndex = 0;

    if (!this.slider || !this.nextButton) return;

    this.init();
  }

  init() {
    // 1. Setup Listeners
    this.nextButton.addEventListener('click', () => this.slideNext());
    this.prevButton.addEventListener('click', () => this.slidePrev());

    // 2. Setup touch/swipe support
    this.initSwipe();
  }

  updateSliderPosition() {
    const slideWidth = this.sliderItems[0].clientWidth;
    console.log('slideWidth')
    console.log(slideWidth)
    this.slider.scrollLeft = slideWidth * this.currentIndex;
  }

  slideNext() {
    console.log('click slideNext')
    if (this.currentIndex < this.sliderItems.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Loop to start
    }
    this.updateSliderPosition();
  }

  slidePrev() {
    console.log('click slidePrev')
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.sliderItems.length - 1; // Loop to end
    }
    this.updateSliderPosition();
  }

  initSwipe() {
    let startX = 0;
    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });

    this.slider.addEventListener('touchend', (e) => {
      const diffX = startX - e.changedTouches[0].clientX;
      if (diffX > 50) this.slideNext();
      if (diffX < -50) this.slidePrev();
    });
  }
}

customElements.define('base-slider', BaseSlider);

// Product Carousel


class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.carousel-slides');
  }

  connectedCallback() {
    // Setup Previous/Next trigger bindings
    this.querySelectorAll('[data-action]').forEach(button => {
      button.addEventListener('click', () => this.scroll(button.dataset.action));
    });
  }

  scroll(direction) {
    const slideWidth = this.slider.querySelector('.carousel-slide').offsetWidth;
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    const scrollAmount = slideWidth + gap;

    if (direction === 'next') {
      this.slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    } else {
      this.slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  }
}
customElements.define('product-carousel', ProductCarousel);